import { baseURL } from './config'

export default {
  // SOCKET_URL: 'http://10.0.0.10:3001/'
  // SOCKET_URL: 'https://smv2.cmremedios.com.br/socket.io/'
  // SOCKET_URL: 'https://iconerec.drmedpro.com.br/'
  SOCKET_URL: baseURL
}
